import * as React from 'react';
import { Icon, View } from 'smoothie';

import {
    type GoalCategoryDescription,
    GoalColors,
    GoalIcons,
    GoalSecondaryColors,
} from '../../types/Goal';

interface GoalCategoryIconProps {
    goalCategoryDescription: GoalCategoryDescription;
}

const GoalCategoryIcon = ({
    goalCategoryDescription,
}: GoalCategoryIconProps) => {
    return (
        <View
            height={60}
            width={60}
            borderRadius={8}
            backgroundColor={GoalColors[goalCategoryDescription]}
            alignItems="center"
            justifyContent="center"
        >
            <Icon
                icon={GoalIcons[goalCategoryDescription]}
                size={20}
                color={GoalSecondaryColors[goalCategoryDescription]}
            />
        </View>
    );
};

export default GoalCategoryIcon;
